import {
  useProductPriceHistoryQuery,
  UseProductPriceHistoryQueryParams,
} from "../queries/useProductPriceHistory.query";
import { IPagination } from "../../../interfaces/IPagination";
import { TProductPriceHistory } from "../types/productPriceHistory.types";

type Response = {
  productPriceHistories: TProductPriceHistory[];
  paginationData?: IPagination;
  isLoading: boolean;
};

export const useProductPriceHistories = (
  opt: UseProductPriceHistoryQueryParams,
): Response => {
  const { data, isLoading } = useProductPriceHistoryQuery(opt);
  return {
    productPriceHistories: data?.data?.productPriceHistories || [],
    paginationData: data?.data?.pagination,
    isLoading,
  };
};
